import { doccenHTTPRequest } from '../services/axios/httpRequest';

export const getUserAgent = async () => {
  return doccenHTTPRequest.get('/users/user-agent');
};
